import type { FormSubmissionResponse } from '@qdf/shared';
import { FormLayout } from '../layout/FormLayout.js';

interface NwConfirmationPageProps {
  submission: FormSubmissionResponse;
  onStartNew: () => void;
}

export function NwConfirmationPage({ submission, onStartNew }: NwConfirmationPageProps) {
  return (
    <FormLayout>
      <div className="text-center py-8">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-success-50 mb-6">
          <svg
            className="w-8 h-8 text-success-500"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
          </svg>
        </div>

        <h2 className="text-2xl font-bold text-gray-900 mb-2">Application Submitted</h2>
        <p className="text-gray-600 mb-8">
          Thank you for applying with New Western. Our team will review your request and you
          will hear from us by email once a decision has been made.
        </p>

        <div className="bg-gray-50 rounded-lg p-6 inline-block text-left mb-8">
          <dl className="space-y-3">
            <div>
              <dt className="text-xs font-medium text-gray-500 uppercase tracking-wider">
                Tracking ID
              </dt>
              <dd className="text-lg font-mono font-semibold" style={{ color: 'var(--color-nw-charcoal)' }}>
                {submission.submissionId}
              </dd>
            </div>
          </dl>
        </div>

        <p className="text-sm text-gray-500 mb-6">
          A confirmation email with your tracking ID is on its way to your inbox. Please keep
          it for your records — you'll receive one more email once your application is reviewed.
        </p>

        <button
          type="button"
          onClick={onStartNew}
          className="px-6 py-2 rounded-lg border border-gray-300 text-sm font-medium text-gray-700
            hover:bg-gray-50 transition-colors"
        >
          Submit Another Application
        </button>
      </div>
    </FormLayout>
  );
}
